export default {
    // Header Section
    "discover_your": "ನಿಮ್ಮ",
    "sadesati": "ಸಾಡೇಸತಿ",
    "saturn_influence_analysis": "ಶನಿಯ ಪ್ರಭಾವ ವಿಶ್ಲೇಷಣೆ",
    "sadesati_description": "ಶನಿಯ ನಿಮ್ಮ ಜೀವನದ ಮೇಲಿನ ಪ್ರಭಾವದ ವಿಸ್ತೃತ ವಿಶ್ಲೇಷಣೆಯನ್ನು ಪಡೆಯಿರಿ, ಸವಾಲುಗಳನ್ನು ಬೆಳವಣಿಗೆ ಮತ್ತು ಯಶಸ್ಸಿನ ಅವಕಾಶಗಳಾಗಿ ಪರಿವರ್ತಿಸಲು ಒಳನೋಟಗಳು ಮತ್ತು ಪರಿಹಾರಗಳೊಂದಿಗೆ.",

    "sadesati_your": "ಸಾಡೇಸತಿ ವಿಶ್ಲೇಷಣೆ",

    // Service Information
    "enter_details_for_sadesati": "ಸಾಡೇಸತಿ ವಿಶ್ಲೇಷಣೆಗಾಗಿ ನಿಮ್ಮ ವಿವರಗಳನ್ನು ನಮೂದಿಸಿ",
    "complete_sadesati_analysis": "ಸಂಪೂರ್ಣ ಸಾಡೇಸತಿ ವಿಶ್ಲೇಷಣೆ",
    "service_price": "ಸೇವೆಯ ಬೆಲೆ",
    "comprehensive_sadesati_analysis_note": "ಶನಿಯ ಸಂಕ್ರಮಣ ಪರಿಣಾಮಗಳ ಆಳವಾದ ವಿಶ್ಲೇಷಣೆ ಮತ್ತು ವೈಯಕ್ತಿಕ ಪರಿಹಾರ ಮಾರ್ಗದರ್ಶನ",

    // Form Fields
    "full_name": "ಪೂರ್ಣ ಹೆಸರು",
    "enter_full_name": "ನಿಮ್ಮ ಪೂರ್ಣ ಹೆಸರನ್ನು ನಮೂದಿಸಿ",
    "name_saturn_influence": "ನಿಮ್ಮ ಹೆಸರಿನ ಕಂಪನಗಳು ಶನಿಯ ಶಕ್ತಿ ಮಾದರಿಗಳೊಂದಿಗೆ ಸಂವಹನ ನಡೆಸುತ್ತವೆ",
    "email_address": "ಇಮೇಲ್ ವಿಳಾಸ",
    "enter_email_address": "ನಿಮ್ಮ ಇಮೇಲ್ ವಿಳಾಸವನ್ನು ನಮೂದಿಸಿ",
    "phone_number": "ದೂರವಾಣಿ ಸಂಖ್ಯೆ",
    "enter_phone_number": "ನಿಮ್ಮ ದೂರವಾಣಿ ಸಂಖ್ಯೆಯನ್ನು ನಮೂದಿಸಿ",
    "gender": "ಲಿಂಗ",
    "male": "ಪುರುಷ",
    "female": "ಮಹಿಳೆ",
    "other": "ಇತರೆ",
    "date_of_birth": "ಜನ್ಮ ದಿನಾಂಕ",
    "birth_date_moon_position": "ನಿಮ್ಮ ಚಂದ್ರ ರಾಶಿ ಮತ್ತು ಸಾಡೇಸತಿ ಹಂತವನ್ನು ನಿರ್ಧರಿಸಲು ಅಗತ್ಯವಾದುದು",
    "time_of_birth": "ಜನ್ಮ ಸಮಯ",
    "exact_time_critical_for_sadesati": "ನಿಖರವಾದ ಚಂದ್ರ ರಾಶಿ ಲೆಕ್ಕಾಚಾರಕ್ಕೆ ನಿಖರವಾದ ಸಮಯ ಅಗತ್ಯ",
    "place_of_birth": "ಜನ್ಮ ಸ್ಥಳ",
    "place_of_birth_placeholder": "ನಗರ, ರಾಜ್ಯ, ದೇಶ",
    "location_essential_for_sadesati": "ಸ್ಥಳ ನಿರ್ದೇಶಾಂಕಗಳು ಗ್ರಹಗಳ ಲೆಕ್ಕಾಚಾರಗಳ ಮೇಲೆ ಪರಿಣಾಮ ಬೀರುತ್ತವೆ",
    "preferred_language": "ಆದ್ಯತೆಯ ಭಾಷೆ",
    "english": "ಇಂಗ್ಲಿಷ್",
    "hindi": "ಹಿಂದಿ",
    "telugu": "ತೆಲುಗು",
    "kannada": "ಕನ್ನಡ",
    "language_note": "ನಿಮ್ಮ ಸಾಡೇಸತಿ ವಿಶ್ಲೇಷಣೆಯನ್ನು ಆಯ್ಕೆಮಾಡಿದ ಭಾಷೆಯಲ್ಲಿ ತಲುಪಿಸಲಾಗುವುದು",

    // Core SadeSati Features
    "sadesati_phase_identification": "ಸಾಡೇಸತಿ ಹಂತ ಗುರುತಿಸುವಿಕೆ",
    "saturn_effects_analysis": "ಶನಿಯ ಪರಿಣಾಮಗಳ ವಿಶ್ಲೇಷಣೆ",
    "remedies_and_solutions": "ಪರಿಹಾರಗಳು ಮತ್ತು ಪರಿಹಾರಗಳು",
    "timeline_predictions": "ಟೈಮ್‌ಲೈನ್ ಭವಿಷ್ಯವಾಣಿಗಳು",
    "life_guidance_during_sadesati": "ಸಾಡೇಸತಿ ಸಮಯದಲ್ಲಿ ಜೀವನ ಮಾರ್ಗದರ್ಶನ",
    "pdf_download": "ಸಮಗ್ರ PDF ವರದಿ",

    "what_you_get": "ನಿಮ್ಮ ಸಾಡೇಸತಿ ವಿಶ್ಲೇಷಣೆಯು ಏನನ್ನು ಒಳಗೊಂಡಿದೆ",
    "complete_sadesati_timeline": "ಸಂಪೂರ್ಣ ಸಾಡೇಸತಿ ಟೈಮ್‌ಲೈನ್",
    "saturn_influence_analysis": "ಶನಿಯ ಪ್ರಭಾವ ವಿಶ್ಲೇಷಣೆ",
    "personalized_remedies": "ವೈಯಕ್ತಿಕ ಪರಿಹಾರಗಳು",
    "life_guidance_insights": "ಜೀವನ ಮಾರ್ಗದರ್ಶನ ಮತ್ತು ಒಳನೋಟಗಳು",

    // Actions & Buttons
    "pay_and_generate_analysis": "ನನ್ನ ಸಾಡೇಸತಿ ವಿಶ್ಲೇಷಣೆಯನ್ನು ಪಡೆಯಿರಿ",
    "processing_payment": "ಪಾವತಿಯನ್ನು ಪ್ರಕ್ರಿಯೆಗೊಳಿಸಲಾಗುತ್ತಿದೆ",
    "processing_request": "ವಿಶ್ಲೇಷಣೆಯನ್ನು ರಚಿಸಲಾಗುತ್ತಿದೆ",

    // Payment & Success Messages
    "thank_you": "ಧನ್ಯವಾದಗಳು",
    "payment_successful": "ಪಾವತಿ ಯಶಸ್ವಿಯಾಗಿದೆ!",
    "sadesati_analysis_processing": "ನಿಮ್ಮ ಸಾಡೇಸತಿ ವಿಶ್ಲೇಷಣೆಯನ್ನು ನಮ್ಮ ತಜ್ಞ ವೈದಿಕ ಜ್ಯೋತಿಷಿಗಳು ತಯಾರಿಸುತ್ತಿದ್ದಾರೆ. ನಿಮ್ಮ ಜೀವನದ ಮೇಲೆ ಶನಿಯ ಪ್ರಸ್ತುತ ಪ್ರಭಾವದ ವಿಸ್ತೃತ ಒಳನೋಟಗಳನ್ನು ನೀವು ಸ್ವೀಕರಿಸುವಿರಿ.",
    "order_id": "ಆರ್ಡರ್ ID",
    "payment_id": "ಪಾವತಿ ID",
    "amount_paid": "ಪಾವತಿಸಿದ ಮೊತ್ತ",

    // Delivery Information
    "delivery_information": "ವಿತರಣಾ ಮಾಹಿತಿ",
    "delivery_time": "ವಿಶ್ಲೇಷಣೆ ವಿತರಣೆ",
    "within_12_hours_delivery_note": "ನಿಮ್ಮ ವಿಸ್ತೃತ ಸಾಡೇಸತಿ ವರದಿ 12 ಗಂಟೆಗಳೊಳಗೆ ಸಿದ್ಧವಾಗುತ್ತದೆ",
    "whatsapp_notification": "WhatsApp ಅಪ್‌ಡೇಟ್‌ಗಳು",
    "whatsapp_delivery_note": "WhatsApp ನಲ್ಲಿ ತತ್ಕ್ಷಣ ಸೂಚನೆಗಳನ್ನು ಸ್ವೀಕರಿಸಿ",
    "email_delivery": "ಇಮೇಲ್ ವಿತರಣೆ",
    "email_delivery_note": "ಸಂಪೂರ್ಣ ವಿಶ್ಲೇಷಣೆಯನ್ನು ತಲುಪಿಸಲಾಗಿದೆ",

    // What You'll Receive
    "what_youll_receive": "ನಿಮ್ಮ ಸಾಡೇಸತಿ ವಿಶ್ಲೇಷಣೆ ಪ್ಯಾಕೇಜ್",
    "detailed_sadesati_report": "ಸಮಗ್ರ ಸಾಡೇಸತಿ ವರದಿ (PDF)",
    "saturn_phase_analysis": "ಶನಿ ಹಂತ ಮತ್ತು ಟೈಮ್‌ಲೈನ್ ವಿಶ್ಲೇಷಣೆ",
    "remedial_measures_guidance": "ಪರಿಹಾರ ಕ್ರಮಗಳು ಮತ್ತು ಮಾರ್ಗದರ್ಶನ",
    "life_predictions_timeline": "ಜೀವನ ಭವಿಷ್ಯವಾಣಿಗಳು ಮತ್ತು ಟೈಮ್‌ಲೈನ್",
    "spiritual_guidance_saturn": "ಶನಿ ಅವಧಿಗೆ ಆಧ್ಯಾತ್ಮಿಕ ಮಾರ್ಗದರ್ಶನ",

    // Visual Content
    "sample_sadesati_analysis": "ಮಾದರಿ ಸಾಡೇಸತಿ ವಿಶ್ಲೇಷಣೆ",
    "sadesati_phase": "ಸಾಡೇಸತಿ ಹಂತ",
    "sample_sadesati_description": "ಪ್ರಸ್ತುತ ಪೀಕ್ ಹಂತದಲ್ಲಿ - ಗರಿಷ್ಠ ಶನಿ ಪ್ರಭಾವ ಅವಧಿ",
    "sample_sadesati_preview": "ಹಂತ ವಿವರಗಳೊಂದಿಗೆ ನಿಮ್ಮ ವೈಯಕ್ತಿಕ ಸಾಡೇಸತಿ ವಿಶ್ಲೇಷಣೆಯ ಪೂರ್ವವೀಕ್ಷಣೆ",
    "sadesati_phases": "ಸಾಡೇಸತಿ ಹಂತಗಳು",

    // SadeSati Phase Types
    "rising_phase": "ಏರುವ ಹಂತ",
    "peak_phase": "ಪೀಕ್ ಹಂತ",
    "setting_phase": "ಅಸ್ತ ಹಂತ",

    // Status & Processing
    "your_sadesati_analysis_status": "ನಿಮ್ಮ ಸಾಡೇಸತಿ ವಿಶ್ಲೇಷಣೆಯ ಸ್ಥಿತಿ",
    "processing_your_analysis": "ಶನಿಯ ಪ್ರಭಾವವನ್ನು ವಿಶ್ಲೇಷಿಸಲಾಗುತ್ತಿದೆ",
    "analysis_processing_message": "ನಮ್ಮ ವೈದಿಕ ಜ್ಯೋತಿಷ್ಯ ತಜ್ಞರು ಶನಿಯ ಪ್ರಸ್ತುತ ಸ್ಥಾನ ಮತ್ತು ನಿಮ್ಮ ಜೀವನ ಮಾರ್ಗದ ಮೇಲಿನ ಅದರ ಪರಿಣಾಮಗಳನ್ನು ಅಧ್ಯಯನ ಮಾಡುತ್ತಿದ್ದಾರೆ.",
    "request_id": "ವಿಶ್ಲೇಷಣೆ ID",
    "status": "ಸ್ಥಿತಿ",
    "processing": "ಪ್ರಗತಿಯಲ್ಲಿದೆ",
    "pending": "ಸಾಲಿನಲ್ಲಿದೆ",
    "email_notification_sent": "ದೃಢೀಕರಣ ಇಮೇಲ್ ಕಳುಹಿಸಲಾಗಿದೆ",
    "whatsapp_update_coming": "WhatsApp ಅಪ್‌ಡೇಟ್‌ಗಳನ್ನು ಸಕ್ರಿಯಗೊಳಿಸಲಾಗಿದೆ",
    "delivery_within_12_hours": "12 ಗಂಟೆಗಳೊಳಗೆ ವರದಿ ಸಿದ್ಧ",

    // Support & Contact
    "contact_support": "ಜ್ಯೋತಿಷ್ಯ ಬೆಂಬಲವನ್ನು ಸಂಪರ್ಕಿಸಿ",
    "need_help": "ಮಾರ್ಗದರ್ಶನ ಬೇಕೇ?",
    "contact_us_at": "ನಮ್ಮನ್ನು ಇಲ್ಲಿ ಸಂಪರ್ಕಿಸಿ",

    // Error Messages
    "please_fill_all_required_fields": "ದಯವಿಟ್ಟು ಎಲ್ಲಾ ಅಗತ್ಯವಾದ ಜನ್ಮ ವಿವರಗಳನ್ನು ಪೂರ್ಣಗೊಳಿಸಿ",
    "payment_failed": "ಪಾವತಿ ವಿಫಲವಾಗಿದೆ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
    "processing_failed": "ವಿಶ್ಲೇಷಣೆ ಪ್ರಕ್ರಿಯೆ ವಿಫಲವಾಗಿದೆ. ನಮ್ಮ ಬೆಂಬಲ ತಂಡವನ್ನು ಸಂಪರ್ಕಿಸಿ.",

    // SadeSati-Specific Elements
    "saturn_transit": "ಶನಿ ಸಂಕ್ರಮಣ",
    "moon_sign": "ಚಂದ್ರ ರಾಶಿ (ರಾಶಿ)",
    "saturn_position": "ಶನಿಯ ಪ್ರಸ್ತುತ ಸ್ಥಾನ",
    "sadesati_duration": "ಸಾಡೇಸತಿ ಅವಧಿ",
    "phase_timeline": "ಹಂತ ಟೈಮ್‌ಲೈನ್",
    "saturn_effects": "ಶನಿಯ ಪರಿಣಾಮಗಳು",

    // Phase Analysis
    "first_phase": "ಮೊದಲ ಹಂತ (2.5 ವರ್ಷಗಳು)",
    "second_phase": "ಎರಡನೇ ಹಂತ (2.5 ವರ್ಷಗಳು)",
    "third_phase": "ಮೂರನೇ ಹಂತ (2.5 ವರ್ಷಗಳು)",
    "phase_characteristics": "ಹಂತದ ಗುಣಲಕ್ಷಣಗಳು",
    "phase_challenges": "ಹಂತದ ಸವಾಲುಗಳು",
    "phase_opportunities": "ಹಂತದ ಅವಕಾಶಗಳು",

    // Effects & Influences
    "career_effects": "ವೃತ್ತಿ ಮತ್ತು ವೃತ್ತಿಪರ ಪರಿಣಾಮಗಳು",
    "health_effects": "ಆರೋಗ್ಯ ಮತ್ತು ಯೋಗಕ್ಷೇಮ ಪರಿಣಾಮಗಳು",
    "relationship_effects": "ಸಂಬಂಧದ ಪರಿಣಾಮಗಳು",
    "financial_effects": "ಹಣಕಾಸಿನ ಪ್ರಭಾವ",
    "mental_effects": "ಮಾನಸಿಕ ಮತ್ತು ಭಾವನಾತ್ಮಕ ಪರಿಣಾಮಗಳು",
    "spiritual_effects": "ಆಧ್ಯಾತ್ಮಿಕ ಬೆಳವಣಿಗೆಯ ಪರಿಣಾಮಗಳು",

    // Remedies & Solutions
    "saturn_remedies": "ಶನಿ ಪರಿಹಾರಗಳು",
    "gemstone_recommendations": "ರತ್ನ ಶಿಫಾರಸುಗಳು",
    "mantra_chanting": "ಮಂತ್ರ ಜಪ",
    "fasting_recommendations": "ಉಪವಾಸ ಮಾರ್ಗಸೂಚಿಗಳು",
    "charity_suggestions": "ದತ್ತಿ ಚಟುವಟಿಕೆಗಳು",
    "worship_rituals": "ಪೂಜಾ ಆಚರಣೆಗಳು",
    "lifestyle_changes": "ಜೀವನಶೈಲಿ ಮಾರ್ಪಾಡುಗಳು",

    // Timeline & Predictions
    "current_phase": "ಪ್ರಸ್ತುತ ಹಂತ",
    "remaining_duration": "ಉಳಿದ ಅವಧಿ",
    "next_phase_start": "ಮುಂದಿನ ಹಂತದ ಪ್ರಾರಂಭ ದಿನಾಂಕ",
    "sadesati_end_date": "ಸಾಡೇಸತಿ ಅಂತ್ಯ ದಿನಾಂಕ",
    "monthly_predictions": "ಮಾಸಿಕ ಭವಿಷ್ಯವಾಣಿಗಳು",
    "yearly_overview": "ವಾರ್ಷಿಕ ಅವಲೋಕನ",

    // Detailed Analysis Sections
    "saturn_mythology": "ವೈದಿಕ ಪುರಾಣಗಳಲ್ಲಿ ಶನಿ",
    "karmic_lessons": "ಕಾರ್ಮಿಕ ಪಾಠಗಳು",
    "past_life_karma": "ಪೂರ್ವ ಜನ್ಮದ ಕರ್ಮ",
    "spiritual_significance": "ಆಧ್ಯಾತ್ಮಿಕ ಮಹತ್ವ",
    "growth_opportunities": "ಬೆಳವಣಿಗೆಯ ಅವಕಾಶಗಳು",
    "life_lessons": "ಶನಿಯಿಂದ ಜೀವನ ಪಾಠಗಳು",

    // Practical Guidance
    "do_and_dont": "ಸಾಡೇಸತಿ ಸಮಯದಲ್ಲಿ ಮಾಡಬೇಕಾದುದು ಮತ್ತು ಮಾಡಬಾರದುದು",
    "precautions": "ತೆಗೆದುಕೊಳ್ಳಬೇಕಾದ ಮುನ್ನೆಚ್ಚರಿಕೆಗಳು",
    "best_practices": "ಅತ್ಯುತ್ತಮ ಅಭ್ಯಾಸಗಳು",
    "meditation_practices": "ಧ್ಯಾನ ಅಭ್ಯಾಸಗಳು",
    "yoga_recommendations": "ಯೋಗ ಶಿಫಾರಸುಗಳು",
    "dietary_guidelines": "ಆಹಾರ ಮಾರ್ಗಸೂಚಿಗಳು",

    // Support & Guidance
    "coping_strategies": "ನಿಭಾಯಿಸುವ ತಂತ್ರಗಳು",
    "stress_management": "ಒತ್ತಡ ನಿರ್ವಹಣೆ",
    "emotional_support": "ಭಾವನಾತ್ಮಕ ಬೆಂಬಲ ತಂತ್ರಗಳು",
    "family_guidance": "ಕುಟುಂಬ ಸಂಬಂಧ ಮಾರ್ಗದರ್ಶನ",
    "professional_guidance": "ವೃತ್ತಿಪರ ಜೀವನ ಮಾರ್ಗದರ್ಶನ",

    // Advanced Analysis
    "saturn_aspects": "ಶನಿಯ ದೃಷ್ಟಿಗಳು",
    "planetary_combinations": "ಗ್ರಹಗಳ ಸಂಯೋಜನೆಗಳು",
    "dasha_analysis": "ದಶಾ ಅವಧಿ ವಿಶ್ಲೇಷಣೆ",
    "transit_effects": "ಸಂಕ್ರಮಣ ಪರಿಣಾಮಗಳು",
    "yogas_formed": "ಶನಿಯೊಂದಿಗೆ ರೂಪುಗೊಂಡ ಯೋಗಗಳು"
};
